import { I18n } from "../services/I18n";
import "./generated/site-translations-hr";
import common_hr from "../../../../../libs/ps/restaumatic-common/locales/hr.json";
import core_types_sites_hr from "../../../../../libs/ps/restaumatic-core-types-sites/locales/hr.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  hr: { _core_types_sites: core_types_sites_hr },
});
I18n.translations = I18n.extend(I18n.translations, {
  hr: { _common: common_hr },
});
